import React from "react";
import { makeStyles, Paper, Typography, Chip } from "@material-ui/core";
import { i18n } from "../../../translate/i18n";
import InfoTip from "./InfoTip";

const WA_GREEN = "#00a884";

const useStyles = makeStyles((theme) => ({
  section: { padding: theme.spacing(2) },
  title: { marginBottom: theme.spacing(1), fontWeight: 600 },
  empty: { color: "#888", fontSize: 14 },
}));

const pct = (frac) => `${Math.round((frac ?? 0) * 100)}%`;

const TagsPanel = ({ stats, isTV = false }) => {
  const classes = useStyles();
  const data = stats?.interesadoComprar;

  return (
    <Paper className={classes.section} elevation={2}>
      <Typography className={classes.title}>
        {i18n.t("aiAssistantStats.kpis.tagsTrackeados")}
        <InfoTip tipKey="etiquetas" isTV={isTV} />
      </Typography>
      {!data ? (
        <div className={classes.empty}>
          {i18n.t("aiAssistantStats.empty.noTags")}
        </div>
      ) : (
        <Chip
          size="small"
          label={`${i18n.t("aiAssistantStats.kpis.interesadoComprar")}: ${data.count ?? 0} (${pct(data.pctTotal)})`}
          style={
            (data.count ?? 0) > 0
              ? { backgroundColor: WA_GREEN, color: "#fff" }
              : undefined
          }
        />
      )}
    </Paper>
  );
};

export default TagsPanel;
